import { render, staticRenderFns } from "./LoginNew.vue?vue&type=template&id=59b70835&scoped=true&"
import script from "./LoginNew.vue?vue&type=script&lang=js&"
export * from "./LoginNew.vue?vue&type=script&lang=js&"
import style0 from "./LoginNew.vue?vue&type=style&index=0&id=59b70835&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b70835",
  null
  
)

export default component.exports